import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import { useSelector, useDispatch } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import * as action from '../../../store/actions/cart';
import * as actions from '../../../store/actions/auth';
import { isEmpty } from '../../../validation';
import { removeToCart, clearCartItem } from '../../../store/actions/cart';
import { passwordRegex } from '../../../validation/validation';
import swal from 'sweetalert';
import { addCartDevices, getCartDevices,EmptyCartDevices, removeCartDevices,removeCartDevice, getCartDevice } from '../../../services/cartDevices';
import { toast } from 'react-toastify';



const initialValuesLogin = {
    username: '',
    password: ''
}

const initialValuesRegister = {
    username: '',
    email: '',
    password1: '',
    password2: '',
}


const CartPage = (props) => {
    const dispatch = useDispatch();
    const cartData = useSelector(state => state.cart);
    const [Data, setData]=useState((localStorage.getItem('CartItems')))
    const [isLogin, setIsLogin] = useState(true)
    const [total, setTotal] = useState(0)
    const [show, setShow] = useState(false);
    const [cartDevciesData, setCartDevicesData] = useState()
    const [rate, setRate] = useState()
    const [requestId, setRequestId] = useState()
    const token= useSelector(state => state.auth.token);
    const [data, setdata] = useState(false)
    

    const [userName, setUserName] = useState({ 
        firstName: "",
        lastName: "",
        username:"",
        email: "",
        pk: ""})
   
    const section1Ref=useRef()
        const scrollToSection = (ref) => {
            ref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    };
    const useWindowWidth = () => {
        const [windowWidth, setWindowWidth] = useState(window.innerWidth);
      
        useEffect(() => {
          const handleResize = () => setWindowWidth(window.innerWidth);
          window.addEventListener('resize', handleResize);
      
          return () => window.removeEventListener('resize', handleResize);
        }, []);
      
        return windowWidth;
      };
      
    const windowWidth = useWindowWidth();
    const userid=localStorage.getItem("UserId")
    function getUniqueByKey(list1, list2, key) {
        // Create Set of key values for faster lookup
        const list2Keys = new Set(list2.map(obj => obj[key]));
        const list1Keys = new Set(list1.map(obj => obj[key]));
        
        // Find objects unique to each list
        const uniqueInList1 = list1.filter(obj => !list2Keys.has(obj[key]));
        const uniqueInList2 = list2.filter(obj => !list1Keys.has(obj[key]));
        
        return [...uniqueInList1, ...uniqueInList2];
      }
    
    useEffect(()=>{
       // if(cartData.items.length>0){
          //  cartData.items.map((item)=>{
                
           // addCartDevices(item).then()
       // })}
        if(props.token){
            getCartDevices(userid).then((res)=>{
                
                if(res.data.results.length>0&&res.data.results[0].cartuserdevices.length>0){
                    console.log(res.data.results[0].cartuserdevices)
                    var CartUserData=res.data.results[0].cartuserdevices
                    //setdata(true)
                    //console.log(CartUserData)
                    const getUniqueArrayBy=(arr, key)=> {
                        return [...new Map(arr.map(item => [item[key], item])).values()]
                     } 
                    //var mergedArray = CartUserData.concat(cartData.items);
                    //console.log(mergedArray)
                        
                   // var uniqueDevice = getUniqueByKey(CartUserData,cartData.items,'deviceId')
                    //console.log(uniqueDevice)
                    if(CartUserData.length>0){
                        let list1=[]
                        let list2=[]
                        CartUserData.map((i)=>{
                           
                            var hasItemCart=cartData.items.some(item=>item.deviceId===i.deviceId)
                            //var hasItemDb=CartUserData.some(item=>item.id===i.id)
                            console.log(hasItemCart)
                            //console.log(hasItemDb)
                            if(!hasItemCart){
                                
                                list1.push(i)
    
                                
                            }
                            console.log(list1)
                        }

                        
                    );
                    list1.map((item)=>{
                        dispatch(action.addToCart(item))
                        toast.info("we have retrieved device (s) from your previous session and added to box, if you want your can discard them from box.")
                    })
                    cartData.items.map((i)=>{
                        console.log(i.deviceId)
    
                        //var hasItemCart=cartData.items.some(item=>item.id===i.id)
                        let list=[]
                        var hasItemDb=CartUserData.some(item=>item.deviceId===i.deviceId)
                        //console.log(hasItemCart)
                        console.log(hasItemDb)
                        if(!hasItemDb){
                            
                            list2.push(i)
                            
                        }
                        console.log(list2)
                        
                    }
                );addCartDevices({user:Number(localStorage.getItem("UserId")),
                    user_no:Number(localStorage.getItem("UserId")),cartuserdevices:list2}).then(res=>{
                    if(res){
                        console.log(res)
                    
                    }
                }).catch(err=>{
                    console.log(err)
                })
                     
    
                    }
           
            }else if(res.data.results.length>0&&res.data.results[0].cartuserdevices.length===0)
            {
                let list=[]
                cartData.items.map((item)=>{
                    list.push(item)
                    
                })
                if(list.length>0){
                    addCartDevices({user:Number(localStorage.getItem("UserId")),
                        user_no:Number(localStorage.getItem("UserId")),cartuserdevices:list}).then(res=>{
                        if(res){
                            console.log(res)
                        
                        }
                    }).catch(err=>{
                        console.log(err)
                    })
                }
                
            }
            else{
                let list=[]
                cartData.items.map((item)=>{
                    list.push(item)
                    
                })
                if(list.length>0){
                    addCartDevices({user:Number(localStorage.getItem("UserId")),
                        user_no:Number(localStorage.getItem("UserId")),cartuserdevices:list}).then(res=>{
                        if(res){
                            console.log(res)
                        
                        }
                    }).catch(err=>{
                        console.log(err)
                    })
                }
            }
            }).catch((err)=>{
            console.log(err)
            
            })
        }
            
        
       
                  //var devices=response
                  ////const uniquedevices = getUniqueByKey(cartData.items, devices, 'deviceId');
                  //console.log(uniquedevices);
                  //console.log(devices)
                    //uniquedevices.map((item)=>{
                        //dispatch(action.addToCart(item))
                        //console.log("this is working")
                   // })
                },[props.token]) 
                
    useEffect(() => {
        var total = cartData && cartData.items.length > 0 &&
        cartData.items.reduce((a, { deviceOffer }) => a + parseInt(deviceOffer), 0)   
        setTotal(total);
      
        const getUniqueArrayBy=(arr, key)=> {
            return [...new Map(arr.map(item => [item[key], item])).values()]
         }   
      if(Data){
        
        console.log("hi")
        //var mergedArray = JSON.parse(Data).concat(cartData.items);
        //var uniqueDevice = getUniqueArrayBy(mergedArray,'deviceId')
        
        //var uniqueDevice = Array.from(new Set(mergedArray.map(item => item.deviceId)))
       {/* {cartData.items.map((i,j)=>{
            if(!uniqueDevice.includes(i.deviceId)){
                
            }

        })}*/}
        //cartData.items= uniqueDevice
       
        {/*var total = cartData && cartData.items.length > 0 &&
        cartData.items.reduce((a, { deviceOffer }) => a + parseInt(deviceOffer), 0)   
        setTotal(total);*/}
       // cartList=cartData.items.length
      }
        
        //console.log(uniqueDevice)
       // var mergedArray1=JSON.stringify(mergedArray)
        //console.log(mergedArray)
        //console.log(cartData.items)
    
            
        
        
    }, [cartData,])
    
    



    const removeCartById = (id) => {
        swal({
            title: "Are you sure?",
            text: "Want to delete this item from the box",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete)=>{
            if(willDelete){
                dispatch(removeToCart(id))
                if(props.token){
                    var results
                    var device_id;
                    var user_id=Number(localStorage.getItem("UserId"))
                    getCartDevice(user_id).then((res)=>{
                        if(res){
                            console.log(res.data.results)
                            results=res.data.results
                            results.map((item)=>{
                                if(item.deviceId===id){
                                    device_id=Number(item.id)
                                }
                            })
                           
                            console.log(device_id)
                            removeCartDevices(device_id).then((res)=>{
                                if(res){
                                    console.log(res)
                                }
                            }).catch((err)=>{
                                console.log(err)
                            })
                        }
                    }).catch((err)=>{
                        console.log(err)
                    })
                    
                }
               
            }})

          
       
    }
    const EmptyCart = (id) => {
        swal({
            title: "Are you sure?",
            text: "Want to delete all item from the box",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete)=>{
            if(willDelete){
                dispatch(clearCartItem())
                localStorage.removeItem("CartItems")
                if(props.token){
                    var cart_id;
                    var id= Number(localStorage.getItem("UserId"))
                    getCartDevices(id).then((res)=>{
                        if(res){
                            console.log(res.data)
                            cart_id=res.data.results[0].id
                            console.log(cart_id)
                            EmptyCartDevices(cart_id).then((res)=>{
                                if(res){
                                    console.log(res)
                                }
                            }).catch((err)=>{
                                console.log(err)
                            })
                        }
                    }).catch((err)=>{
                        console.log(err)
                    })
                    
                    
                }
              
                }
               
               // window.location.reload()
            })

          
       
    }
    
     
           
           

    const handleClose = () => setShow(false);
  

    const addMoreDevice = () => {
        props.history.push("/SellADevice");
    }

    const loginOrRegister = () => {
        props.history.push('/login')
    }

    const handleLogin = async (values) => {
        const res = await props.onAuth(values.username, values.password);
        if (res && res.status) {
            props.history.push('/cart/payment');
        }
    }

    const handleRegister = async (values) => {
        const res = await props.onRegister(values.username, values.email, values.password1, values.password1);
        if (res && res.status) {
            props.history.push("/cart/address");
        }
    }

    const checkOutAsGust = () => {
        props.totalPayment(total)
        if (total <= 1) {
            props.history.push("/cart/address");
        } else {
            props.history.push('/cart/payment');
        }
    }

    const loginSchema = Yup.object().shape({
        username: Yup.string()
            .required('Please input your username!'),
        password: Yup.string()
            .required('Please input your password!'),
    });

    const registerSchema = Yup.object().shape({
        username: Yup.string()
            .required('Please input your username!'),
        email: Yup.string()
            .required('Please input your email!')
            .email('Invalid email'),
        password1: Yup.string()
            .required('Please input your password1!')
            .matches(passwordRegex, "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
            ),
        password2: Yup.string()
            .required('Please input your password2!')
            .oneOf([Yup.ref('password1'), null], 'Password1 do not match'),
    });

    return (
        <div className='vh-70'>
        <div className="container p-2 mb-2" >
            <div>
            <button className='text-dark h5 border-dark rounded-bottom   my-2 w-100'>
               Your Box
            </button>
            <div className='container-3'>
           
           
            
            {isEmpty(cartData.items)&& <>
            <span className='h6 text-Dark strong'> <p>Your box is empty add devices to the box</p></span>
           
            
                <img className="img-width" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Misc_Sellmydevices/images.jpeg"/>
            
            </>
            }
           {!isEmpty(cartData.items)&&
            <Button className="my-2 mx-2 p-1" variant="outline-danger rounded-lg" onClick={() => EmptyCart()}>
                <strong className=''> Empty Box </strong>
            </Button>
           } 
           {!isEmpty(cartData.items)&&windowWidth < 768 && cartData.items.length>3&&
          
            <Button className="w-100 outline-dark bg-warning" onClick={()=>scrollToSection(section1Ref)} ><strong className='text-dark'>Checkout </strong></Button>
          }
             
           
            

           
            {
                !isEmpty(cartData.items) && cartData.items.map((item, index) => (
                    <div className=" " key={index} >
                                            
                                                       
                                            <div className='p-2 ml-2'>
                                                      
                                                        <div className='d-flex item-3'>
                                                            <div className='bg-gren w-50'>
                                                                <div className=''>
                                                                <div>
                                                                <img className="w-50 h-25 bg-white" src={item.deviceImages} /> 
                                                            </div>
                                                            <div className="ml-2"style={{fontSize:12, fontWeight:'bold'}}>
                                                            {item.deviceModel}
                                                            </div>
                                                       
                                                        <div className=''>
                                                        {item.deviceOffer === 0 &&
                                                            <button className="rounded-lg mt-1 bg-green w-100 p-2" style={{ fontSize:12, }}  > <strong>Recycling...</strong></button>
                                                        }
                                                        {item.deviceOffer != 0 &&
                                                            <button className="rounded-lg mt-1 bg-warning w-100 p-2" style={{ fontSize: 12, color:'black' }}  > <strong>Today's offer: ${item.deviceOffer}</strong></button>
                                                        }
                                                        </div> 
                                                        </div>
                                                        </div>
                                                        <div className='bg- e w-50'>
                                                        <div className=" ">
                                                            {item.deviceCapacity&&
                                                               <>
                                                               <button className='rounded bg-white ml-2 border border-dark' style={{fontSize:12, color:'black'}}>
                                                                {item.deviceCapacity}  </button>
                                                               <br></br>
                                                               </>
                                                               
                                                                }
                                                                {item.deviceRAM&&
                                                               <>
                                                               <button className='rounded bg-white ml-2 border border-dark' style={{fontSize:12, color:'black'}}>
                                                                {item.deviceRAM}  </button>
                                                               <br></br>
                                                               </>
                                                               
                                                                }
                                                                   
                                                            {item.deviceGeneration&&
                                                            <>
                                                            <button className='rounded mt-1 bg-white border border-dark  ml-2' style={{fontSize:12, color:'black'}}> 
                                                                
                                                                {item.deviceGeneration}
                                                                </button> 
                                                                <br></br>
                                                                </>
                                                                    }
                                                                      
                                                            {item.deviceType!=="MacBook"&&
                                                            item.deviceType&&
                                                            <>
                                                            <button className='rounded mt-1  bg-white border border-dark ml-2' style={{fontSize:12, color:'black'}}> 
                                                                 {item.deviceType}
                                                                </button> 
                                                                <br></br></>
                                                            
                                                            }
                                                            {item.deviceCarrier&&item.deviceCarrier!=0&&
                                                                 <>
                                                                  <button className='rounded mt-1 border bg-white border-dark  ml-2' style={{fontSize:12, color:'black'}}> 
                                                                    {item.deviceCarrier}
                                                                    </button> 
                                                                    <br></br>
                                                                    </>
                                                              
                                                            }
                                                            {item.deviceYear&&
                                                            <>
                                                            <button className='rounded bg-white mt-1  border border-dark  ml-2' style={{fontSize:12,color:'black'}}> 
                                                                {item.deviceYear}
                                                                </button> 
                                                                 <br></br></>
                                                            
                                                            }
                                                            {item.deviceProcessor&&
                                                            <>
                                                             <button  className='rounded bg-white mt-1 border border-dark  ml-2' style={{fontSize:12,color:'black'}}> 
                                                                {item.deviceProcessor}
                                                                </button> 
                                                                <br></br></>
                                                           
                                                            }
                                                              
                                                        
                                                        {item.deviceSize && item.deviceSize!=0 &&
                                                            <>
                                                            <button className="rounded bg-white  mt-1   border border-dark  ml-2" style={{ fontSize: 12, color:'black' }}>
                                                                {item.deviceSize}
                                                            </button>
                                                            <br />
                                                            </>
                                                        }
                                                        {item.deviceEdition &&item.deviceEdition!=0&& 
                                                            <>
                                                            <button className="rounded bg-white mt-1   border border-dark ml-2" style={{ fontSize: 12, color:'black' }}>
                                                               {item.deviceEdition}
                                                            </button>
                                                            <br />
                                                            </>
                                                        }
                                                        {item.deviceBand &&item.deviceBand !=0 &&
                                                            <>
                                                            <button className="rounded bg-white mt-1 border  border-dark  ml-2" style={{ fontSize: 12, color:'black' }}>
                                                               {item.deviceBand}
                                                            </button>
                                                            <br />
                                                            </>
                                                        }
                                                        
                                                        {item.deviceCondition && (
                                                            <>
                                                            <button className="rounded bg-white mt-1  border border-dark  ml-2" style={{ fontSize: 12, color:'black' }}>
                                                            
                                                            {item.deviceCondition}
                                                            </button>
                                                            <br />
                                                            </>
                                                            
                                                        
                                                        )}
                                                       </div> 
                                                    </div>
                                     
                                                       <div className=''> 
                                                           <span className="float-right text-danger cursor-pointer" onClick={() => removeCartById(item.deviceId)}><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-trash" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                               <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                               <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                           </svg></span>  
                                                       </div>    
                                                    </div>
                                                        
                     
                                             </div>
        
                                                       
                                    </div>
                    
                ))
            }
            <hr/>
            {
                isEmpty(cartData.items) &&
                <div className="mt-3 mb-3 col d-flex">
                    
                    
                    <button className="border-dark mt-2 rounded-lg p-2 w-100" position="center" onClick={() => addMoreDevice()}  variant=""><svg width="2em" height="2em" viewBox="0 0 16 16" className="bi bi-plus-circle-fill mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg"onClick={() => addMoreDevice()}>
                        <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4a.5.5 0 0 0-1 0v3.5H4a.5.5 0 0 0 0 1h3.5V12a.5.5 0 0 0 1 0V8.5H12a.5.5 0 0 0 0-1H8.5V4z" />
                    </svg>Add devices to box to sell to us</button>
                </div>
            }
            {
                !isEmpty(cartData.items) &&
                <div className="mt-3 mb-3 col d-flex">
                    
                    
                    <button className="border-dark mt-2 rounded-lg p-2 w-100"position="center" onClick={() => addMoreDevice()}  variant=""><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-plus-circle-fill mr-2 " fill="currentColor" xmlns="http://www.w3.org/2000/svg" onClick={() => addMoreDevice()}>
                        <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4a.5.5 0 0 0-1 0v3.5H4a.5.5 0 0 0 0 1h3.5V12a.5.5 0 0 0 1 0V8.5H12a.5.5 0 0 0 0-1H8.5V4z" />
                    </svg>Add more devices to sell </button>
                </div>
            }
            {
                !isEmpty(cartData.items) &&
                <Button className="w-100 mr-2" variant="outline-dark rounded-lg">
                     <strong className='float-left'> Box Subtotal : </strong><strong className="float-right mr-2">${total} </strong>
                </Button>
            }
           {/*<Button className="my-2 mx-2" variant="outline-danger rounded-lg" onClick={() => clickShipLoginAttempt()}>
                <strong className=''> shippingrate </strong>
            </Button>*/ } 
            
            {
                isLogin && !isEmpty(cartData.items) && !props.token &&
                <>
                <div className="row mt-4 justify-content-center" ref={section1Ref}>
                    <div className="col-md-4">
                        <Button className="w-100 border-dark" onClick={() => checkOutAsGust()} ><strong className='text-dark'>Checkout as a Guest </strong></Button>
                    </div>
                    <div className="col-md-1">
                        <div className="text-center">
                        <div className='my-2 mx-2 h4'>
                           Or 
                   
                     <br /></div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <Button className="w-100 border-dark" onClick={() =>props.history.push("/Login")} ><strong className='text-dark'> Login/Register to Checkout</strong></Button>
                        
                    </div>
                </div>
                <div>
                    <p className='mx-4 my-3 ' style={{fontSize: "14px"}}>We recommend to create the account if don't have one! if you are a existing customer kindly sign in to proceed, 
                        registered user have more way to track their orders and its more convenient for you to get notify of each steps during the process. </p>
                </div>

                </>

            }

            {
                isLogin && !isEmpty(cartData.items) && props.token &&
                <div className="row mt-4 justify-content-center" ref={section1Ref}>
                    <div className="col-md-4 mb-4">
                        <Button className="w-100" onClick={() => checkOutAsGust()} variant="outline-dark bg-warning"><strong>Checkout</strong>  </Button>
                    </div>
                </div>

            }


            {!isLogin &&
                <div className="row mt-5">
                    <div className="col-md-12 ml-4 mb-1">
                        <h4>Log In</h4>
                    </div>
                    <div className="col-md-12">
                        <Formik
                            initialValues={initialValuesLogin}
                            onSubmit={handleLogin}
                            validationSchema={loginSchema}
                        >
                            {({ isSubmitting }) => (
                                <Form>
                                    <div className="row">
                                        <div className="col-md-8">
                                            <label className="col-md-2 mt-2">
                                                Username:
                                           </label>
                                            <div className="col-md-10">
                                                <Field className="form-control" type="text" name="username" />
                                                <ErrorMessage name="username" className="text-danger" component="div" />
                                            </div>
                                        </div>

                                        <div className="col-md-8">
                                            <label className="col-md-2 mt-2">
                                                Password:
                                            </label>
                                            <div className="col-md-10">
                                                <Field className="form-control" type="password" name="password" />
                                                <ErrorMessage name="password" className="text-danger" component="div" />
                                            </div>
                                        </div>

                                        <div className="col-md-8">
                                            <div className="col-md-10 pt-3">
                                                <button type="submit" className="btn btn-primary mr-2">
                                                    Login
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                    <div className="col-md-6 text-center text-bold">
                        <h6>
                           ________ Or _______<br />
                     Create Account (Register)
                        </h6>
                    </div>
                    <div className="col-md-12">
                        <Formik
                            initialValues={initialValuesRegister}
                            onSubmit={handleRegister}
                            validationSchema={registerSchema}
                        >
                            {({ isSubmitting }) => (
                                <Form>
                                    <div className="row">
                                        <div className="col-md-8">
                                            <label className="col-md-2 mt-2">
                                                Username:
                                           </label>
                                            <div className="col-md-10">
                                                <Field className="form-control" type="text" name="username" />
                                                <ErrorMessage name="username" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <label className="col-md-2 mt-2">
                                                Email:
                                           </label>
                                            <div className="col-md-10">
                                                <Field className="form-control" type="text" name="email" />
                                                <ErrorMessage name="email" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <label className="col-md-2 mt-2">
                                                Password1:
                                           </label>
                                            <div className="col-md-10">
                                                <Field className="form-control" placeholder="Enter your password" type="password" name="password1" />
                                                <ErrorMessage name="password1" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <label className="col-md-2 mt-2">
                                                Password2:
                                           </label>
                                            <div className="col-md-10">
                                                <Field className="form-control" placeholder="Confirm your password" type="password" name="password2" />
                                                <ErrorMessage name="password2" className="text-danger" component="div" />
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="col-md-10 pt-3">
                                                <button type="submit" className="btn btn-primary mr-2">
                                                    Register
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                        
                    </div>
                </div>

            }
        </div>
            </div>
             
        </div>
        </div>
    )
}

const mapStateToProps = state => {
        return {
            token: state.auth.token,
            items: state.cart.items,
        
        }
    }





const mapDispatchToProps = dispatch => {
    return {
        onAuth: (username, password) => dispatch(actions.authLogin(username, password)),
        onRegister: (username, email, password1, password2) => dispatch(actions.authSignup(username, email, password1, password2)),
        totalPayment: (value) => dispatch(action.updateTotalPayment(value))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CartPage);
